import { atom } from "recoil";

export const connected = atom({
  key: "connected",
  default: {
    connected: false,
    account: null,
  },
});
